'use strict';

module.exports = {
  white: '#FFFFFF',
  grey: '#AAB2BD',
  greySmoke: '#F5F7FA',
  greylight: '#CCD1D9',
  greyMedium: '#656D78',
  greyDark: '#434A54',
  greyDarker: '#353B48',
  primary: '#428BCA',
  primaryDarker: '#2B5C86',
  success: '#5CB85C',
  warning: '#F89D0E',
  error: '#D9534F',
  black: '#000000'
};
